<div [class]="wrapperClass()">
  <button
    type="button"
    id="notification_bell_button"
    [class]="buttonClass()"
    [attr.aria-label]="'notification_page_title' | transloco"
    [attr.aria-expanded]="isOpen()"
    (click)="toggle()">
    @if (placement() === 'side') {
      <lib-side-menu-icon name="bell" [iconClass]="iconClass()" />
    } @else {
      <lib-notification-icon [iconClass]="iconClass()" />
    }
    @if (feed.hasUnread()) {
      <span
        data-unread-dot
        class="absolute top-[.125rem] end-[.125rem] w-[.5rem] h-[.5rem] bg-destructive-500 rounded-full"></span>
    }
  </button>
  @if (isOpen()) {
    <div
      data-notification-panel
      libClickOutSide
      [stopPropagations]="true"
      (clickOutside)="close()"
      [class]="panelClass()"
      [style.height]="panelHeight()">
      <div class="overflow-y-auto flex-1 min-h-0">
        <lib-notification
          [notifications]="feed.notifications()"
          width="100%"
          height="100%"
          [maxNotifications]="10"
          noStateIconSize="size-20"
          (notificationClick)="markRead($event)"
          (settingsClick)="openSettings()"
          (markAllAsRead)="feed.markAllRead()"
          (viewDetailsClick)="openNotification($event)"></lib-notification>
      </div>
      <div
        class="p-lg bg-white flex justify-center flex-shrink-0 border-t border-neutral-200">
        <button
          type="button"
          (click)="goToNotifications()"
          class="py-sm px-lg gap-md text-neutral-700 font-medium text-sm bg-white border border-neutral-300 rounded-lg shadow-xs">
          {{ 'see_all_notifications_button' | transloco }}
        </button>
      </div>
    </div>
  }
</div>
